import { FileTextIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'

export const ExportG1N5: React.FC = () => {
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()
  const { setG1n5FormOpen } = useKestrelViewerContext()

  const handleOpenForm = () => {
    setG1n5FormOpen(true)
    trackButtonClicked({
      button_name: 'kestrel_export_g1n5',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Export G1N5 Form'}>
      <ViewToggle onClick={handleOpenForm}>
        <FileTextIcon width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
